/**
 * Cashier Config Extend
 */

define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var cashierConfig = require('portlets/cashier/cashier.config');
    /**
     * Represents cashier config for all methods or chosen type+method
     * @param {String} [aspect] - 'method.methodType' selector for method and method type; Both parts are optional
     * @returns Object
     */
    module.exports = function() {
        var config = cashierConfig.apply(this, arguments);

        if (config && config.validationConfig) {
            config.validationConfig.personalId = {
                required: true,
                length: {
                    min: 8,
                    max: 18,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.personalID.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9]+$/,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.personalID.regexp')
                }
            };
        }

        return config;
    };
});
